export default "__VITE_ASSET__BiYkYCh3__"